/**
 * Created by contrapro on 03/04/2018
 */

// import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import loginReducer from './login';
import timeModalReducer from './timeModalReducer';
import crmAnalyticsReducer from './crmAnalyticsReducer';
import richModalReducer from './richModalReducer';
import userReducer from './userReducer';
import errorReducer from './errorReducer';
import messageReducer from './message';
import viewStateReducer from './viewStateReducer';
import workReducer from './work';

export default combineReducers({
    loginReducer,
    userReducer,
    messageReducer,
    richModalReducer,
    timeModalReducer,
    errorReducer,
    // crmAnalyticsReducer,
    viewStateReducer,
    workReducer
    // routing: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js